import React, { Component } from "react";
import { Link } from "react-router-dom";

class ModuleFiltersSimple extends Component {
  render() {
    const { onSearchButtonClick, addLink, addTitle, searchByTitle } =
      this.props;
    return (
      <React.Fragment>
        <input
          id="keyword"
          className="input"
          placeholder={
            searchByTitle === "" || searchByTitle === undefined
              ? "Search by keyword"
              : "Search by " + searchByTitle
          }
        />
        <button
          onClick={() =>
            onSearchButtonClick(document.getElementById("keyword").value)
          }
          id="searcBtn"
          className="btn btn--primary"
          type="button"
        >
          Search
        </button>

        <button
          onClick={function () {
            document.getElementById("keyword").value = "";
            document.getElementById("searcBtn").click();
          }}
          className="btn btn--secondary"
          type="button"
        >
          Reset
        </button>
        <div className="filters_spacer"></div>
        <Link to={addLink} className="btn btn--accent" style={{ margin: 0 }}>
          + {addTitle}
        </Link>
      </React.Fragment>
    );
  }
}

export default ModuleFiltersSimple;
